import React from 'react';
import useEmblaCarousel from 'embla-carousel-react';

const steps = [
  { 
    number: 1, 
    title: "Capture", 
    description: "Paste anything. Screenshot, link, note. Don't think, just save." 
  },
  { 
    number: 2, 
    title: "Find", 
    description: "Search naturally. AI knows what you meant, not just what you typed." 
  },
  { 
    number: 3, 
    title: "Create", 
    description: "Drag to canvas. Arrange spatially. See your ideas come together." 
  }
];

export const HowItWorks = () => {
  const [emblaRef] = useEmblaCarousel({ 
    align: 'start',
    containScroll: 'trimSnaps',
  });

  return (
    <section className="pt-16 pb-20 px-6 sm:px-10 lg:px-16 bg-white">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-12 sm:mb-16 tracking-tight">How it works</h2>
        
        {/* Desktop view - horizontal flow */}
        <div className="hidden sm:flex flex-row gap-4 items-start justify-between relative">
          {/* Connecting line (desktop only) */}
          <div className="absolute top-8 left-[calc(16.67%+2rem)] right-[calc(16.67%+2rem)] h-px bg-border" />
          
          {steps.map((step, i) => (
            <div key={i} className="flex-1 text-center">
              <div className="relative z-10 w-16 h-16 rounded-full bg-[#ff5c35]/10 text-[#ff5c35] font-bold text-xl flex items-center justify-center mx-auto mb-4 border-4 border-white">
                {step.number}
              </div>
              <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
              <p className="text-muted-foreground leading-relaxed max-w-xs mx-auto">{step.description}</p>
            </div>
          ))}
        </div>
        
        {/* Mobile view - swipeable carousel */}
        <div className="sm:hidden">
          <div className="overflow-hidden" ref={emblaRef}>
            <div className="flex gap-4">
              {steps.map((step, i) => (
                <div key={i} className="flex-[0_0_85%] min-w-0 text-center px-2">
                  <div className="relative z-10 w-16 h-16 rounded-full bg-[#ff5c35]/10 text-[#ff5c35] font-bold text-xl flex items-center justify-center mx-auto mb-4">
                    {step.number}
                  </div>
                  <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
                  <p className="text-muted-foreground leading-relaxed">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
          {/* Carousel dots indicator */}
          <div className="flex justify-center gap-2 mt-6">
            {steps.map((_, i) => (
              <div key={i} className="w-2 h-2 rounded-full bg-[#ff5c35]/30" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
